const SKELETON_ROWS = ['r1', 'r2', 'r3', 'r4', 'r5', 'r6', 'r7', 'r8', 'r9', 'r10']

/** Loading placeholder for the order tables on the Orders page. */
export function OrdersTableSkeleton() {
  return (
    <div className="animate-pulse overflow-hidden rounded-[16px] border-2 border-gray-200 bg-white">
      <div className="h-11 bg-brand-primary" />
      <div className="divide-y divide-gray-100">
        {SKELETON_ROWS.map((key) => (
          <div key={key} className="flex items-center gap-4 p-3">
            <div className="h-4 w-24 rounded bg-gray-200" />
            <div className="h-4 w-28 rounded bg-gray-100" />
            <div className="h-4 w-32 rounded bg-gray-100" />
            <div className="ml-auto h-4 w-16 rounded bg-gray-200" />
          </div>
        ))}
      </div>
    </div>
  )
}
